import React from 'react'
import { Box, Button, Modal, Typography } from '@mui/material'
import { Error } from '@mui/icons-material'
import { ReactComponent as Green } from '../../Assets/green_csv.svg'
import { ReactComponent as GreenUser } from '../../Assets/green_user.svg'

import ErrorDialog from './ErrorDialog.jsx'
import ConfirmActionDialog from './ConfirmActionDialog.jsx'

const TITLE_ID = 'csv-dialog-title'
const DESCRIPTION_ID = 'csv-dialog-description'

const CsvDialog = ({ open, handleClose, type, message }) => {
  const title = type === 'uploading' ? 'Upload complete' : type === 'user' ? 'Invitation sent' : 'Error'

  return (
    <Modal
      open={open}
      onClose={handleClose}
      role={type === 'error' ? 'alertdialog' : 'dialog'}
      aria-labelledby={TITLE_ID}
      aria-describedby={DESCRIPTION_ID}
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        backgroundColor: 'background.paper',
        boxShadow: 24,
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: 'center',
        borderRadius: '0.5rem',
      }}>
        {type === 'uploading' ? <Green width={'8rem'}/> : type === 'user' ? <GreenUser width={'8rem'}/> : <Error sx={{ color: 'red', fontSize: '8rem' }}/>}
        <Typography id={TITLE_ID} sx={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>
          {title}
        </Typography>
        <Typography id={DESCRIPTION_ID} sx={{
          fontWeight: '400',
          textAlign: 'center',
          fontSize: '1.1rem',
          color: '#424242',
          margin: '1rem 0 2rem 0',
        }}>
          {type === 'uploading' ? 'Your file has been uploaded successfully.' : type === 'user' ? 'Your invitation has been sent successfully.' : message}
        </Typography>
        <Button variant='outlined' sx={{
          padding: '0.5rem 5rem',
          color: '#0071f4',
          backgroundColor: '#fff',
          border: '1px solid #0071f4',
          textTransform: 'none',
          borderRadius: '0.5rem',
          fontSize: '1.25rem',
        }} onClick={handleClose}>
          OK
        </Button>
      </Box>
    </Modal>
  )
}

export default CsvDialog
export { ConfirmActionDialog, ErrorDialog }
